<script lang="ts" setup>
import YesNo from '~/components/icons/YesNo.vue'
import helpers from '~/helpers'
import { useCartStore } from '~/store/cart'

const cartStore = useCartStore()

const tableHeaders = { gift: 'Подарок', condition: 'Условие', isConditionMet: 'Условие выполнено' }

function formatName (name: string): string {
  return name.replace(
    /(?:(?:до|на|от)\s|)(?:\d+\s)*\d+(?:,\d+|)\s₽/gi,
    (x: string): string => x.replace(/\s+/, '\xA0')
  )
}
</script>

<template>
  <BlockWithBorder v-if="cartStore.gifts.length">
    <div class="h4">
      Получите подарок
    </div>

    <table>
      <thead>
        <tr>
          <th v-for="x in Object.values(tableHeaders)" :key="x">
            {{ x }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="x in cartStore.gifts" :key="x.name">
          <td :data-label="tableHeaders.gift">
            {{ formatName(x.name) }}
          </td>
          <td :data-label="tableHeaders.condition">
            Сумма товаров: от&nbsp;{{ helpers.formatPrice(x.minSubtotalInKopecks, true) }}&nbsp;₽
            <template v-if="isFinite(x.maxSubtotalInKopecks)">
              до&nbsp;{{ helpers.formatPrice(x.maxSubtotalInKopecks, true) }}&nbsp;₽
            </template>
            <template v-if="x.minSubtotalInKopecks - cartStore.subtotalWithDiscountInKopecks > 0">
              (осталось: {{ helpers.formatPrice(x.minSubtotalInKopecks - cartStore.subtotalWithDiscountInKopecks, true) }}&nbsp;₽)
            </template>
          </td>
          <td :data-label="tableHeaders.isConditionMet">
            <YesNo
              :value="cartStore.subtotalWithDiscountInKopecks >= x.minSubtotalInKopecks
                && cartStore.subtotalWithDiscountInKopecks < x.maxSubtotalInKopecks"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </BlockWithBorder>
</template>
